
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FluteStub"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Flute"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_abbreviation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wavelength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waveheight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shear_stiffness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"takeup_factor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight_limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"knockdown_limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"knockdown_slope"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TST_alpha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TST_eta"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":211}};
    doc.loc.source = {"body":"fragment FluteStub on Flute  {\n  id\n  name\n  company\n  company_abbreviation\n  wavelength\n  waveheight\n  shear_stiffness\n  takeup_factor\n  weight_limit\n  knockdown_limit\n  knockdown_slope\n  TST_alpha\n  TST_eta\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/admin/FluteStubFragment.graphql
// module id = mIYL
// module chunks = 1